module.exports = __webpack_public_path__ + "static/media/shia-5.9102c4a1.mp3";